import React from "react";

const InstagramSVG = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.017 2.5H7.947C6.37015 2.50185 4.85844 3.12914 3.74353 4.24424C2.62862 5.35933 2.00159 6.87115 2 8.448L2 16.518C2.00185 18.0948 2.62914 19.6066 3.74424 20.7215C4.85933 21.8364 6.37115 22.4634 7.948 22.465H16.018C17.5948 22.4631 19.1066 21.8359 20.2215 20.7208C21.3364 19.6057 21.9634 18.0938 21.965 16.517V8.447C21.9631 6.87015 21.3359 5.35844 20.2208 4.24353C19.1057 3.12862 17.5938 2.50159 16.017 2.5V2.5ZM19.957 16.517C19.957 17.0344 19.8551 17.5468 19.6571 18.0248C19.4591 18.5028 19.1689 18.9371 18.803 19.303C18.4371 19.6689 18.0028 19.9591 17.5248 20.1571C17.0468 20.3551 16.5344 20.457 16.017 20.457H7.947C6.90222 20.4567 5.90032 20.0415 5.16165 19.3026C4.42297 18.5638 4.008 17.5618 4.008 16.517V8.447C4.00827 7.40222 4.42349 6.40032 5.16235 5.66165C5.90122 4.92297 6.90322 4.508 7.948 4.508H16.018C17.0628 4.50827 18.0647 4.92349 18.8034 5.66235C19.542 6.40122 19.957 7.40322 19.957 8.448V16.518V16.517Z"
        fill="#0F172A"
      />
      <path
        d="M11.9818 7.31909C10.6133 7.32121 9.30136 7.86588 8.33372 8.8337C7.36609 9.80152 6.82168 11.1135 6.81982 12.4821C6.82141 13.851 7.36585 15.1634 8.33372 16.1315C9.3016 17.0996 10.6139 17.6442 11.9828 17.6461C13.3519 17.6445 14.6645 17.0999 15.6326 16.1318C16.6007 15.1637 17.1452 13.8512 17.1468 12.4821C17.1447 11.1132 16.5998 9.80098 15.6315 8.83329C14.6633 7.8656 13.3507 7.32141 11.9818 7.32009V7.31909ZM11.9818 15.6381C11.1451 15.6381 10.3426 15.3057 9.7509 14.714C9.15922 14.1223 8.82682 13.3198 8.82682 12.4831C8.82682 11.6463 9.15922 10.8438 9.7509 10.2522C10.3426 9.66049 11.1451 9.32809 11.9818 9.32809C12.8186 9.32809 13.6211 9.66049 14.2127 10.2522C14.8044 10.8438 15.1368 11.6463 15.1368 12.4831C15.1368 13.3198 14.8044 14.1223 14.2127 14.714C13.6211 15.3057 12.8186 15.6381 11.9818 15.6381Z"
        fill="#0F172A"
      />
      <path
        d="M17.1559 8.59509C17.8391 8.59509 18.3929 8.04127 18.3929 7.35809C18.3929 6.67492 17.8391 6.12109 17.1559 6.12109C16.4728 6.12109 15.9189 6.67492 15.9189 7.35809C15.9189 8.04127 16.4728 8.59509 17.1559 8.59509Z"
        fill="#0F172A"
      />
    </svg>
  );
};

export default InstagramSVG;
